import {Home} from '@/layout'

export default {
    path: '/school',
    component: Home,
    meta: {
        roles: ['school'],
        childrenRoles: false
    },
    children: [
        {
            path: '',
            component: () => import('@/page/school'),
            children: [
                {
                    path: '',
                    meta: {
                        title: '校区信息'
                    },
                    component: () => import('@/page/school/info')
                },
                {
                    path: 'students',
                    meta: {
                        title: '用户管理'
                    },
                    component: () => import('@/page/school/students')
                },
                {
                    path: 'teachers',
                    meta: {
                        title: '校区老师'
                    },
                    component: () => import('@/page/school/teachers')
                },
                {
                    path: 'classes',
                    meta: {
                        title: '班级管理'
                    },
                    component: () => import('@/page/school/classes')
                },
            ]
        }
    ]
}
